import { device } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';
import {
  BodyExtraSmall,
  BodyLarge,
  BodyLargeBold,
  BodyRegularSemiBold,
  BodySmallMedium,
  Heading4,
  Heading6,
} from '@src/fonts/typography/Typography';
import { DarkTextColor } from '@src/fonts/typography/TypographyColors';
import { darken } from 'polished';
import styled, { css } from 'styled-components';

export const AuthContainer = styled.div`
  display: flex;
  position: relative;
  flex-flow: column;
  padding: 16px;
  margin: 0 auto;
  max-width: 800px;
  background-color: ${LayoutColors.whiteDark};
  border-radius: 8px;

  ${device.smallTablet} {
    padding: 24px;
  }
`;

export const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AuthHeader = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;

  ${device.smallTablet} {
    margin-bottom: 16px;
    gap: 24px;
  }
`;

export const AuthHeaderTitle = styled.h4`
  ${Heading6}
  ${DarkTextColor}

  ${device.smallTablet} {
    ${Heading4}
  }
`;

export const AuthHeaderSubtitle = styled.p`
  color: ${LayoutColors.blackMain};
  ${BodySmallMedium}
  ${device.smallTablet} {
    ${BodyLarge}
  }
`;

export const AuthInputsGrid = styled.div`
  display: grid;
  gap: 16px;
`;

export const AuthValidation = styled.div`
  ${BodyExtraSmall};
  display: block;
  padding-top: 2px;
  color: ${LayoutColors.errorDark};
`;

const ButtonStyled = css`
  ${BodyRegularSemiBold};

  width: 100%;
  padding: 10px 12px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid ${LayoutColors.successDark};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const AuthButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 16px;
  ${BodyRegularSemiBold};
`;

export const AuthPrimaryButton = styled.button`
  ${ButtonStyled};
  color: ${LayoutColors.whiteLight};
  background-color: ${LayoutColors.successDark};
  &:hover {
    background-color: ${darken(0.1, LayoutColors.successDark)};
  }
`;
export const AuthSecondaryButton = styled.button`
  ${ButtonStyled};
  background-color: ${LayoutColors.whiteDark};
  color: ${LayoutColors.successDark};
`;
export const AuthPreviousStepButton = styled.a`
  ${BodyLargeBold};
  cursor: pointer;
  text-decoration: none;
`;

export const AuthInputContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  ${device.smallTablet} {
    grid-template-columns: 1fr 1fr;
  }
`;
